module.exports = __webpack_public_path__ + "static/img/comIcon3.4570d022.png";